import type { IUseTranslation } from "@helium10/re-core";
import { TranslateProvider } from "@helium10/re-core";
import LocalizedStrings from "localized-strings";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import de from "./translates/de.json";
import en from "./translates/en.json";
import es from "./translates/es.json";
import it from "./translates/it.json";
import ja from "./translates/ja.json";
import zh from "./translates/zh_CN.json";

type ILanguage = typeof en;

const strings = new LocalizedStrings(
  { en, de, es, it, zh, ja } as unknown as Record<string, ILanguage>,
  {
    logsEnabled: false,
  },
);

export const MRSTranslateProvider = ({ children }: { children: ReactNode }) => {
  return (
    <TranslateProvider<ILanguage> strings={strings} TranslateContext={TranslateContext}>
      {children}
    </TranslateProvider>
  );
};

const TranslateContext = createContext<IUseTranslation<ILanguage> | null>(null);

export const useTranslation = (): IUseTranslation<ILanguage> => {
  const context = useContext(TranslateContext);
  if (!context) {
    throw new Error("[Translation] The provider is not defined");
  }
  return context;
};
